import { useQuery } from '@hooks/reactQuery';

import { getLatestConfigFileView } from '@api/gNodeBConfigParameters';

import { ILatestConfigFileViewDTO } from '@interfaces/crowdcell/dto/gNodeBConfigDTO';

import { CONFIG_FILE_VIEW } from '@constants/queryKeys';

export const useQueryConfigFileView = ({
	id,
	type,
}: ILatestConfigFileViewDTO) => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONFIG_FILE_VIEW],
		queryFn: () => getLatestConfigFileView({ id, type }),
		enabled: [id],
		refetchOnWindowFocus: false,
	});

	return {
		text: data?.text,
		isLoadingConfigFileView: isLoading || isFetching,
	};
};
